import { render, staticRenderFns } from "./warningComponent.vue?vue&type=template&id=4de13a13"
import script from "./warningComponent.vue?vue&type=script&lang=js"
export * from "./warningComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports